import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { useSubscriptionStatus } from '@/hooks/useBilling';
import { UserRole } from '@/types/enums';
import { SubscriptionStatus } from '@/types/billing';
import { ROUTES } from '@/constants/routes';

interface StaffRouteProps {
  children: React.ReactNode;
}

const StaffRoute: React.FC<StaffRouteProps> = ({ children }) => {
  const { user } = useAuthStore();
  const location = useLocation();
  const { data: subscription } = useSubscriptionStatus();

  if (!user || (user.role !== UserRole.MANAGER && user.role !== UserRole.EMPLOYEE && user.role !== UserRole.ADMIN)) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  const isStaff = user.role === UserRole.MANAGER || user.role === UserRole.EMPLOYEE;

  if (
    isStaff &&
    subscription?.status === SubscriptionStatus.EXPIRED &&
    location.pathname !== ROUTES.BILLING
  ) {
    return <Navigate to={ROUTES.BILLING} replace />;
  }

  return <>{children}</>;
};

export default StaffRoute;
